import React, { useState, useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    useTable,
    usePagination,
} from 'react-table';

import Carousel from './Carousel';

import * as utils from '../../utils';

function RegistryTable({ columns, data, showActions, onAddAction, onEditAction, onRowClick, onPageChange, customBtnGroup, alwaysDisplayTable = true }) {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0 }
        },
        usePagination
    )
    // TODO: пересмотреть реализацию
    const [selectedRowId, selectRow] = useState(undefined);
    const [rowStates, setRowStates] = useState(page.slice().fill(""));
    //

    useEffect(() => {
        if (onPageChange && page && page.length > 0) {
            onPageChange(
                page[0].index,
                page[page.length - 1].index + 1
            );
        }
    }, [page]);

    if (!alwaysDisplayTable && utils.getIsViewportEqual("xs", "sm")) {

        return (
            <Carousel
                objects={
                    data.map((item) => {
                        return (
                            <div className="p-3">
                                {
                                    columns.filter(item => { if (["id", "number"].indexOf(item.accessor) === -1) return item }).map((column) => {
                                        return (
                                            <div className="text-center mt-3">
                                                <div><strong>{column.Header}</strong></div>
                                                <div className="mt-1">{item[column.accessor]}</div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        )
                    })
                }
            />
        )
    }
    else {
        return (
            <div className="registry-table-container">
                {showActions &&

                    <div className="btn-toolbar d-flex justify-content-center">

                        <div className="btn-group registry-actions" role="group" aria-label="Basic example">
                            <button type="button" className="btn btn-secondary" title="Добавить новый элемент" onClick={onAddAction}>
                                <FontAwesomeIcon icon="plus" size="sm" color="#fff" />
                            </button>

                            {onEditAction &&
                                <button disabled={!selectedRowId} type="button" className="btn btn-secondary" title="Редактировать выбранный элемент" onClick={onEditAction}>
                                    <FontAwesomeIcon icon="pencil-alt" size="sm" color="#fff" />
                                </button>
                            }
                            <button disabled={!selectedRowId} type="button" className="btn btn-secondary" title="Удалить выбранный элемент">
                                <a href="#confirmActionModal" data-toggle="modal"><FontAwesomeIcon icon="minus" size="sm" color="#fff" /></a>
                            </button>
                        </div>

                        {customBtnGroup &&
                            customBtnGroup
                        }
                    </div>
                }

                <table {...getTableProps()} className="table table-hover mt-2">
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column, i) => {
                                    if (i != 0) {
                                        if (i > 2) {
                                            return <th className="d-none d-md-table-cell d-lg-table-cell d-xl-table-cell" {...column.getHeaderProps()}>{column.render('Header')}</th>
                                        }
                                        else {
                                            return <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                        }
                                    }
                                })}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {
                            page.map((row, i) => {
                                prepareRow(row)
                                return (
                                    <tr className={rowStates[i]} onClick={() => {
                                        if (onRowClick) {
                                            onRowClick(row.cells[0].value);
                                        }

                                        selectRow(row.cells[0]);

                                        let newRowStates = page.slice().fill("");
                                        newRowStates[i] = "active";

                                        setRowStates(newRowStates)
                                    }
                                    } {...row.getRowProps()}>
                                        {row.cells.map((cell, j) => {
                                            if (j !== 0) {
                                                if (j > 2) {
                                                    return <td className="d-none d-md-table-cell d-lg-table-cell d-xl-table-cell" {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                                }
                                                else {
                                                    return <td  {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                                }
                                            }
                                        })}
                                    </tr>
                                )
                            })}
                    </tbody>
                </table>

                <nav className="mt-4 d-flex justify-content-around align-items-center">
                    <span className="registry-table-nav-item d-none d-md-inline d-lg-inline d-xl-inline">
                        Страница{' '}
                        <strong>
                            {pageIndex + 1} из {pageOptions.length}
                        </strong>{' '}
                    </span>
                    <div className="btn-group registry-table-nav-item" role="group">
                        <button type="button" className="btn btn-secondary" title="В начало" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                            <FontAwesomeIcon icon="angle-double-left" size="sm" color="#fff" />
                        </button>
                        <button disabled={!selectedRowId} type="button" className="btn btn-secondary" title="Назад" onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <FontAwesomeIcon icon="angle-left" size="sm" color="#fff" />
                        </button>
                        <button disabled={!selectedRowId} type="button" className="btn btn-secondary" title="Далее" onClick={() => nextPage()} disabled={!canNextPage}>
                            <FontAwesomeIcon icon="angle-right" size="sm" color="#fff" />
                        </button>
                        <button disabled={!selectedRowId} type="button" className="btn btn-secondary" title="В конец" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                            <FontAwesomeIcon icon="angle-double-right" size="sm" color="#fff" />
                        </button>
                    </div>
                    <select className="registry-table-nav-item d-none d-md-inline d-lg-inline d-xl-inline"
                        value={pageSize}
                        onChange={e => {
                            setPageSize(Number(e.target.value))
                        }}
                    >
                        {[10, 20, 30, 40, 50].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                Показывать по {pageSize}
                            </option>
                        ))}
                    </select>
                </nav>
            </div>
        )
    }
}

export default RegistryTable;